import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import useStyles from "./styles";

const FAQ = () => {
  const [activeTab, setActiveTab] = useState("General Questions");
  const [openIndex, setOpenIndex] = useState(null);
  const classes = useStyles();

  const handleKey = (e, callback) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      callback();
    }
  };

  const faqData = {
    "General Questions": [
      {
        question: "What exactly is SLOT Finance?",
        answer:
          "SLOT Finance is a digital money club for trusted friends. It’s a modern twist on the traditional Ajo system, allowing you and your friends to save, rotate funds, and receive payouts—on your own terms.",
      },
      {
        question: "Can I invite anyone to join my SLOT group?",
        answer: "As easy as this idea sounds, we’re afraid, the answer is a NO! Slot finance works strictly on an “invite only and limited to trusted friend” policy.",
      },
      {
        question: "Is this a loan platform?",
        answer:
          "SLOT finance isn’t a loan platform, it’s an effective saving tool and a financial collaboration platform with inspiration from AJO/ROSCAs.",
      },
      {
        question: "How does the referral system work?",
        answer:
          "The referral system is wholly based on invitations from trusted members, and definitely no room for open sign ups.",
      },
    ],
    // "How Contributions & Payouts Work": [
    //   {
    //     question: "How often do contributions occur?",
    //     answer:
    //       "You can set weekly, biweekly, or monthly cycles when setting up your SLOT group.",
    //   },
    //   {
    //     question: "How are payouts determined?",
    //     answer: "Group members agree on the payout order at the start.",
    //   },
    // ],
    // "Flexibility & Customization": [
    //   {
    //     question: "Can I pause my contributions?",
    //     answer: "Yes, but it must be agreed upon by your group members.",
    //   },
    //   {
    //     question: "Can I change the group size?",
    //     answer: "Only before the cycle starts.",
    //   },
    // ],
    // "Security and Trust": [
    //   {
    //     question: "Is my money safe?",
    //     answer:
    //       "Yes, funds are securely managed and protected with industry-grade encryption.",
    //   },
    //   {
    //     question: "Can people scam others?",
    //     answer:
    //       "All users are vetted, and groups are invite only to prevent fraud.",
    //   },
    // ],
  };

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <h2 className={classes.heading}>FREQUENTLY ASKED QUESTIONS</h2>
        <p className={classes.subtext}>
          Find answers to questions you probably have and get the answer you are
          looking for.
        </p>

        <div className={classes.tabsWrapper}>
          {Object.keys(faqData).map((tab) => (
            <div
              key={tab}
              role="button"
              tabIndex={0}
              onClick={() => {
                setActiveTab(tab);
                setOpenIndex(null);
              }}
              onKeyDown={(e) =>
                handleKey(e, () => {
                  setActiveTab(tab);
                  setOpenIndex(null);
                })
              }
              className={`${classes.tab} ${
                activeTab === tab ? classes.activeTab : ""
              }`}
            >
              {tab}
            </div>
          ))}
        </div>

        <div>
          {faqData[activeTab].map((item, index) => (
            <div key={index} className={`${classes.faqItem} ${openIndex === index ? classes.active : ""}`}>
              <div
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className={classes.questionBtn}
                role="button"
                tabIndex={0}
              >
                <span>{item.question}</span>
                <span>{openIndex === index ? "−" : "+"}</span>
              </div>

              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className={classes.answerText}
                  >
                    {item.answer}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default FAQ;
